import React from 'react';

const MainWrapper = ({ children,className }) => {
    return <section className={`h-[calc(100vh - 80px)] flex-grow overflow-auto ${className} `}>
        {children}
    </section>

};

export default MainWrapper;